var map = {
	"./img1.jpeg": 3244,
	"./img2.jpeg": 6125,
	"./img3.jpeg": 4790,
	"./img4.jpeg": 8623,
	"./img5.jpeg": 7080,
	"./img6.jpeg": 4473,
	"./img7.jpeg": 194,
	"./img8.jpeg": 3819,
	"./img9.jpeg": 1076
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7561;